import { Chip } from "@mui/material";
import React from "react";

interface AuditActionChipProps {
  action: string;
  size?: "small" | "medium";
}

const getAuditActionColor = (action: string): "default" | "error" | "success" => {
  const normalizedAction = action.toLowerCase();

  if (normalizedAction.includes("unassigned")) {
    return "error";
  }

  if (normalizedAction.includes("assigned")) {
    return "success";
  }

  return "default";
};

const formatAuditActionLabel = (action: string) =>
  action.replace(/([a-z])([A-Z])/g, "$1 $2");

const AuditActionChip: React.FC<AuditActionChipProps> = ({
  action,
  size = "small",
}) => {
  const color = getAuditActionColor(action);
  const coloredSx =
    color === "default"
      ? {}
      : {
          "&&": {
            bgcolor: `${color}.main`,
            border: 1,
            borderColor: `${color}.dark`,
            color: "common.white",
          },
          "&&:hover": {
            bgcolor: `${color}.dark`,
          },
        };

  return (
    <Chip
      size={size}
      label={formatAuditActionLabel(action)}
      variant={color === "default" ? "outlined" : "filled"}
      sx={{
        fontWeight: 600,
        ...coloredSx,
        "& .MuiChip-label": {
          px: 1,
        },
      }}
    />
  );
};

export default AuditActionChip;
